import { render, staticRenderFns } from "./ykyjImport.vue?vue&type=template&id=2fbc4b18&scoped=true&"
import script from "./ykyjImport.vue?vue&type=script&lang=js&"
export * from "./ykyjImport.vue?vue&type=script&lang=js&"
import style0 from "./ykyjImport.vue?vue&type=style&index=0&id=2fbc4b18&scoped=true&rel=stylesheet%2Fscss&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbc4b18",
  null
  
)

export default component.exports